import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import React, { useState, useEffect } from "react";
import axios from "axios";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MasterTopButtons from "../../../components/MasterTopButtons/MasterTopButtons";
import Wrapper from "../../../components/UI/Wrapper";
import "../../../pages/SalesMasterPages/PriceCalculator/PriceCalculator.css";
import AddIcon from "@mui/icons-material/Add";

const PriceCalculator = () => {
  const [userDetailResponse, setUserDetailResponse] = useState(null);
  const [serviceType, setServiceType] = useState(1);
  const [MRPSheetResponse, setMRPSheetResponse] = useState(null);
  const [taxableAmount, setTaxableAmount] = useState(0);
  const [gst, setGst] = useState(0);
  const [total, setTotal] = useState([]);
  const [crateDetailResponse, setCrateDetailResponse] = useState(null);
  const [chargableWeightResponse, setChargableWeightResponse] = useState(147);
  const [selectedServices, setSelectedServices] = useState([]);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [petBreedResponse, setPetBreedResponse] = useState([]);

  const baseAPI = process.env.REACT_APP_API_URL;
  const heading = "Calculator";
  const [products, setProducts] = useState([]);

  const [firstItem, setFirstItem] = useState({
    owner_name: "",
    pet_dob: "",
    pet_breed: "",
    date: "",
    crate_size: "",
    airline: "",
    origin: "",
    destination: "",
    buying: "",
    chargeable_wt: "",
    customer_id: "",
    service_type: "",

    createdBy: "Vishal",
    is_active: "true",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem({
      ...firstItem,
      [name]: value,
    });
  };


  const handleChildChange = (productId, childid) => {
    setProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.mrpsheet_id === productId
          ? {
            ...product,
            child_id: childid,
          }
          : product
      )
    );
  }

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    //to get Crate Detail
    axios
      .get(`${baseAPI}userget/GetCrateDetail?cratedetail_id=0`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        //console.log(response.data.data);

        setCrateDetailResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });

    //to get MRP sheet
    axios
      .get(
        `${baseAPI}userget/GetMRPSheetData?opt=1&service_type=1&parent_child=0`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      )
      .then((response) => {
        setProducts(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });

    //to get Pet Breed
    axios
      .get(`${baseAPI}adminget/GEPetBreedType?PetBreedID=0&PetType=0`, {
        headers: {
          Authorization: "Bearer " + storedToken,
        },
      })
      .then((response) => {
        setPetBreedResponse(response.data.data);
      });
  }, []);

  const handleQuantityChange = (productId, childID, newQuantity) => {    
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let targetID;
    const ch_id = isNaN(childID) ? 0 : childID;
    if (ch_id !== null && ch_id !== 0  ) {
      targetID = ch_id;
    } else {
      targetID = productId;
    }
    axios
      .get(
        `${baseAPI}userget/GetCalculation?mrpsheet_id=${targetID}&chargeble_wt=${firstItem.chargeable_wt}&buying=${firstItem.buying}&quantity=${newQuantity}`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      )
      .then((response) => {
        const newTotal = response.data.data[0];
        setProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.mrpsheet_id === productId
              ? {
                ...product,

                quantity: newTotal.quantity,
                taxable_amount: newTotal.taxable_amount,
                GST: newTotal.GST,
                Total: newTotal.Total,
              }
              : product
          )
        );
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  };

  const handleServiceChange = (e) => {
    setServiceType(e.target.value);
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}userget/GetMRPSheetData?opt=1&service_type=${e.target.value}&parent_child=0`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      )
      .then((response) => {
        setProducts(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  };

  const handleCrateSizeChange = (e) => {
    const { name, value } = e.target;
    setFirstItem({
      ...firstItem,
      [name]: value,
    });

    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(
        `${baseAPI}userget/GetCrateDetail?cratedetail_id=${e.target.value}`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      )
      .then((response) => {
        //console.log(response.data.data);
        setChargableWeightResponse(response.data.data[0]);
        setFirstItem((prevItem) => ({
          ...prevItem,
          chargeable_wt: response.data.data[0].chargeable_wt,
        }));
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  };

  const handleSelectChangeChargableWt = (event) => {
    firstItem.chargeable_wt = event.target.value;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();    
  };

  const totalTaxableAmount = products.reduce(
    (acc, product) => acc + (product.taxable_amount || 0),
    0
  );
  const totalTax = products.reduce(
    (acc, product) => acc + (product.GST || 0),
    0
  );
  const totalPrice = products.reduce(
    (acc, product) => acc + (product.Total || 0),
    0
  );

  return (
    <>
      <div className="app-container-PriceCalculator">
        <MiniDrawer />
        <div className="container-fluid container-PriceCalculator">
          <div className="country-header">
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                Price Calculator| <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px" }}>&gt; Price Calculator</span>
              </h1>
              <div>
                <select
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    alignItems: "center",
                    marginBottom: "1rem",
                    width: "18rem",
                  }}
                  className="form-control"
                  name="serviceType"
                  value={serviceType}
                  onChange={handleServiceChange}
                >
                  <option value="1">INTERNATIONAL</option>
                  <option value="2">DOMESTIC</option>
                  <ArrowDropDownIcon />
                </select>
              </div>
            </div>
            <div style={{ width: "8rem" }}>
              <select className="form-control" name="country">
                <option value="0">INDIA </option>
                <option value="1">DUBAI </option>
              </select>
            </div>
          </div>
          <Wrapper className="PriceCalculator">
            <form className="priceCalculator-form" onSubmit={handleSubmit}>
              <table>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>Owner Name</td>
                  <td>Pet DOB</td>
                  <td>Pet Breed</td>
                </tr>

                <tr>
                  <td>
                    <input
                      type="text"
                      name="owner_name"
                      value={firstItem.owner_name}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <input
                      type="date"
                      name="pet_dob"
                      value={firstItem.pet_dob}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <select
                      className="form-control"
                      name="pet_breed"
                      value={firstItem.pet_breed}
                      onChange={handleChange}
                    >
                      <option value="0">Select an option</option>
                      {petBreedResponse.map((item) => (
                        <option value={item.id}>{item.PetBreedType}</option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>Date</td>
                  <td>Crate Size</td>
                  <td>Airline</td>
                </tr>

                <tr>
                  <td>
                    <input
                      type="date"
                      name="date"
                      value={firstItem.date}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <select
                      className="form-control"
                      name="crate_size"
                      onChange={handleCrateSizeChange}
                      value={firstItem.crate_size}
                    >
                      <option value="0">Select an option</option>
                      {crateDetailResponse !== null ? (
                        crateDetailResponse.map((item) => (
                          <option value={item.cratedetail_id}>
                            {item.crate_size}
                          </option>
                        ))
                      ) : (
                        <p>empty</p>
                      )}
                    </select>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="airline"
                      value={firstItem.airline}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>Origin</td>
                  <td>Destination</td>
                  <td>Buying</td>
                </tr>

                <tr>
                  <td>
                    <input
                      type="text"
                      name="origin"
                      value={firstItem.origin}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="destination"
                      value={firstItem.destination}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="buying"
                      value={firstItem.buying}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>Chargeable Wt.</td>
                  <td>Customer Id</td>
                  <td>Service Type</td>
                </tr>

                <tr>
                  <td>
                    <input
                      type="text"
                      name="chargeable_wt"
                      value={firstItem.chargeable_wt}
                      placeholder="Please Enter*"
                      onChange={handleSelectChangeChargableWt}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="customer_id"
                      value={firstItem.customer_id}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <select
                      className="form-control"
                      name="service_type"
                      value={firstItem.service_type}
                      onChange={handleChange}
                    >
                      <option value="0"> Door-to-door </option>
                      <option> Door-to-airport </option>
                      <option> Airport-to-door </option>
                    </select>
                  </td>
                </tr>
              </table>
              <br />
              <hr />
              <div className="reset-addPriceCalculator-button">
                <button style={{ backgroundColor: "#F15843", color: "white" }}>
                  Reset
                </button>
                <button
                  type="submit"
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#5B489D",
                    color: "white",
                  }}                  
                >
                  Save
                </button>
              </div>
            </form>
          </Wrapper>
          <br />
          <Wrapper className="ViewLeadDetails">
            <div className="container-fluid">
              <div className="employeeList">
                <table>
                  <tr className="employeeListHeading">
                    <th>S No.</th>
                    <th>Description</th>
                    <th>Quantity</th>
                    <th>Taxable Amount</th>
                    <th>GST @18%</th>
                    <th>Total</th>
                  </tr>
                  {products !== null ? (
                    products.map((product, index) => (
                      <tr key={product.mrpsheet_id}>
                        <td>{++index}</td>
                        <td style={{ display: 'flex', alignItems: 'center' }}>
                          <span>{product.description}</span>
                          {product.childList !== null && product.childList.length > 0 && (
                            <select
                              className="form-control"
                              name="child_id"
                              value={product.childList.length > 0 ? product.child_id : "0"}
                              onChange={(e) => handleChildChange(product.mrpsheet_id, e.target.value)}
                              style={{ marginLeft: '10px' }}
                            >
                              <option value="0">Select an option</option>
                              {product.childList.map((item) => (
                                <option key={item.mrpsheet_id} value={item.mrpsheet_id}>
                                  {item.description}
                                </option>
                              ))}
                            </select>
                          )}
                        </td>
                        <td>
                          <input
                            type="number"
                            onChange={(e) =>
                              handleQuantityChange(
                                product.mrpsheet_id,
                                parseInt(product.child_id, 0),
                                parseInt(e.target.value, 0)
                              )
                            }
                            min="0"
                          />
                        </td>
                        <td>{product.taxable_amount}</td>
                        <td>{product.GST}</td>
                        <td>{product.Total}</td>
                      </tr>
                    ))
                  ) : (
                    <p>empty</p>
                  )}

                  <tr>
                    <td style={{ textAlign: "right" }} colSpan={4}>
                      Sub Total
                    </td>
                    <td colSpan={2}>{totalTaxableAmount}</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right" }} colSpan={4}>
                      GST @ 18%
                    </td>
                    <td style={{ backgroundColor: "#FFFDC3" }} colSpan={2}>
                      {totalTax}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right" }} colSpan={4}>
                      Total Payable Amount
                    </td>
                    <td style={{ backgroundColor: "#CCFFC3" }} colSpan={2}>
                      {totalPrice}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </Wrapper>
        </div>
      </div>
    </>
  );
};

export default PriceCalculator;
